import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PixWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PixWarningModal: React.FC<PixWarningModalProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-gradient-to-br from-black to-gray-900 border border-luxury-red/30 rounded-xl p-6 max-w-md w-full shadow-2xl">
        {/* Close button */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="absolute top-4 right-4 p-1 h-auto text-gray-400 hover:text-white"
        >
          <X className="h-4 w-4" />
        </Button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-luxury-red/20 rounded-full">
            <AlertTriangle className="h-8 w-8 text-luxury-red" />
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-white text-center mb-3">
          Chave PIX Detectada
        </h3>

        {/* Message */}
        <p className="text-gray-300 text-center mb-6 leading-relaxed">
          Por questões de segurança, não é permitido enviar chaves PIX através do chat. 
          Evite compartilhar informações financeiras sensíveis.
        </p>

        {/* Action button */}
        <div className="flex justify-center">
          <Button
            onClick={onClose}
            className="bg-luxury-red hover:bg-luxury-red/90 text-white px-6 py-2 rounded-lg font-medium transition-all duration-200"
          >
            Entendi
          </Button>
        </div>
      </div>
    </div>
  );
};